module.exports = __webpack_public_path__ + "assets/ca1d823f593ac67e6fbd8afa90d2416f.mp3";